export const endPoints = {
  login: "/api/login",
  refreshToken: "/api/refreshToken",
  forgotPassword: "/api/reset-password/",
  changePassword: "/api/change-password/",
  lastPassword: "api/last-password/",
  passwordTokenValidityCheck: `/api/reset-password/`,
  forgotChangePasswordEndpoint: "/api/reset/change-password/",
  saveBasicProfileDetails: "/api/profile/basic/",
  saveEditedWorkExperience: "/api/profile/work",
  deleteWorkExperience: "/api/profile/work",
  editEducationDetails: "/api/profile/education",
  deleteEducationDetails: "/api/profile/education",
  editLanguage: "/api/profile/language",
  deleteLanguage: "/api/profile/language",
  editUserDetails: "/api/profile/user",
  userDetailsEndpoint: "/api/profile/user",
  updateUserDetailsEndPoint: "/api/profile/user",
  basicUserDetails: "/api/profile/basic",
  updateBasicUserDetails: "/api/profile/basic",
  educationDetailsEndPoint: "/api/profile/education",
  updateEducationDetailsEndPoint: "/api/profile/education",
  workExperienceEndpoint: "/api/profile/work",
  updateWorkExperienceEndPoint: "/api/profile/work",
  keyTraitsEndPoint: "/api/profile/traits",
  updateKeyTraitsEndPoint: "/api/profile/traits",
  resumeUploadEndpoint: "api/resume/uploadFiles",
  loginSendOtp: "/api/send-otp",
  loginVerifyOtp: "/api/verify-otp",
  loginResendOtp: "/api/resend-otp",
  checkCandidateStatus: "/api/check-candidate-status",
  candidateLogin: "/api/candidate-login",
  verifyOtp: "/api/verify-otp-validity",
};
